"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _mobx = require("mobx");
var _serializr = require("serializr");
var _root_model = _interopRequireDefault(require("./root_model"));
var _word = _interopRequireDefault(require("./word"));
var _word_structure = _interopRequireDefault(require("./word_structure"));
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WorksheetWord = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_word["default"])), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_word_structure["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function WorksheetWord() {
    var _this;
    _classCallCheck(this, WorksheetWord);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WorksheetWord, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "worksheetId", _descriptor2, _this);
    _initializerDefineProperty(_this, "position", _descriptor3, _this);
    _initializerDefineProperty(_this, "wordStructureId", _descriptor4, _this);
    _initializerDefineProperty(_this, "hiddenTranslationSourceIds", _descriptor5, _this);
    _initializerDefineProperty(_this, "batchCreateInput", _descriptor6, _this);
    _initializerDefineProperty(_this, "invalidTarget", _descriptor7, _this);
    _initializerDefineProperty(_this, "word", _descriptor8, _this);
    _initializerDefineProperty(_this, "wordStructure", _descriptor9, _this);
    return _this;
  }
  _inherits(WorksheetWord, _RootModel);
  return _createClass(WorksheetWord, [{
    key: "invalid",
    get: function get() {
      var _this$word;
      if (!this.word) {
        return null;
      }
      return ((_this$word = this.word) === null || _this$word === void 0 ? void 0 : _this$word.invalid) || this.invalidPlural || this.invalidTarget;
    }
  }, {
    key: "invalidPlural",
    get: function get() {
      var _this$word2, _this$word3, _this$word4;
      return ((_this$word2 = this.word) === null || _this$word2 === void 0 ? void 0 : _this$word2.isNoun) && !((_this$word3 = this.word) !== null && _this$word3 !== void 0 && _this$word3.plural) && (0, _utils.isBlank)((_this$word4 = this.word) === null || _this$word4 === void 0 ? void 0 : _this$word4.pluralNoun) && !this.word.noPlural;
    }
  }, {
    key: "sourceList",
    get: function get() {
      var _this2 = this;
      if ((0, _lodash.isEmpty)(this.word.translationSources)) {
        return;
      }
      var sourceArray = (0, _lodash.compact)(this.word.translationSources.filter(function (item) {
        var _item$source;
        return item.source && ((_item$source = item.source) === null || _item$source === void 0 ? void 0 : _item$source.languageId) == 'EN' && !item.rejected && (!item.userId || item.accepted) && ((0, _utils.isBlank)(_this2.hiddenTranslationSourceIds) || !_this2.hiddenTranslationSourceIds.includes(item.id));
      }).map(function (item) {
        return _this2.word.sourceTextWithGenderAbbreviation(item.source);
      }));
      return sourceArray.join(', ');
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "worksheetId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "position", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "wordStructureId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hiddenTranslationSourceIds", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "batchCreateInput", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "invalidTarget", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "word", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "wordStructure", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "invalidPlural", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "invalidPlural"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sourceList", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sourceList"), _class.prototype), _class);
var _default = exports["default"] = WorksheetWord;